import { register } from 'swiper/element/bundle';
import 'swiper/css/bundle'

register();

const reviewSliderContainer = document.querySelector('.js-reviews-slider-container')
const sliderElement = reviewSliderContainer.querySelector('.js-slider')

const sliderParams = {
    slidesPerView: 1,
    spaceBetween: '30',
    loop: 'true',
    navigation: {
        nextEl: reviewSliderContainer.querySelector('.js-slider-next'),
        prevEl: reviewSliderContainer.querySelector('.js-slider-prev'),
    },
    pagination: {
        el: reviewSliderContainer.querySelector('.js-slider-pagination'),
        clickable: true,
    },

}

Object.assign(sliderElement, sliderParams)

sliderElement.initialize()
